var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "humburger menu",
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83372 0.31454C1.41401 -0.105172 0.73352 -0.105172 0.313807 0.31454C-0.105905 0.734253 -0.105904 1.41474 0.313808 1.83445L7.47963 9.00028L0.314851 16.1651C-0.104861 16.5848 -0.104862 17.2653 0.31485 17.685C0.734563 18.1047 1.41505 18.1047 1.83476 17.685L8.99955 10.5202L16.1643 17.685C16.584 18.1047 17.2645 18.1047 17.6842 17.685C18.104 17.2653 18.104 16.5848 17.6842 16.1651L10.5195 9.00028L17.6853 1.83445C18.105 1.41474 18.105 0.734253 17.6853 0.31454C17.2656 -0.105172 16.5851 -0.105172 16.1654 0.31454L8.99955 7.48036L1.83372 0.31454Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteExit);
export default __webpack_public_path__ + "static/media/WhiteExit.206109e0c80e272c6c1f49c6fb9c8d1c.svg";
export { ForwardRef as ReactComponent };